import { Box, SimpleGrid, VStack, Text, LinkBox, LinkOverlay } from '@chakra-ui/react'
import { SectionTitle } from '@!/Store/Common/components/SectionTitle'
import { CoverImage } from '@!/Store/Common/components/CoverImage'

const FreeFeature = ({ freeFeature }) => {
  const gtmClick = 'home_free_feature'
  return (
    <Box mx={4}>
      <SectionTitle title={freeFeature.name} url={`/store/free_features/${freeFeature.pathname}`} gtmClick={gtmClick} />
      <SimpleGrid columns={{ base: 3, md: 6 }} spacing={4}>
        {freeFeature.titles.map((title) => (
          <VStack key={title.title_id}>
            <LinkBox w="110px">
              <VStack spacing={0}>
                <Box mb="0.5em">
                  <CoverImage src={title.image_url} alt={title.title_name} objectFit="contain" width="110px" />
                </Box>
                <LinkOverlay href={`/store/books/${title.first_content_id}`} noOfLines={1} fontSize="sm" fontWeight="bold" w="110px" data-gtm-click={gtmClick}>
                  {title.title_name}
                </LinkOverlay>
              </VStack>
            </LinkBox>
            <Box w="100%" borderRadius="3px" bgColor="primary.main" p={0.5}>
              <Text fontSize="3xs" color="label.white" fontWeight="bold" textAlign="center">
                {title.free_volume_count}巻無料
              </Text>
            </Box>
          </VStack>
        ))}
      </SimpleGrid>
    </Box>
  )
}

export default FreeFeature
